<template>
  <div id="codeExplanationModal" class="c-modal">
    <div class="c-modal__content">
      <span class="c-modal__close">&times;</span>
      <div class="u-text-center">
        <!-- <h4>
          Beispiel-Inhalt (2024 DLS Katalog 7 Seite 4):
        </h4> -->
        <img src="@/assets/_led-module-instructions.jpg" width="800" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
